export class RegExp{
  public static validEmailRegEx= '/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
  public static validPhoneRegEx = ' /^[0-9]*$/';
  public static numericReg= '^-?[0-9]\\d*(\\.\\d{1,2})?$'
}
